var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form"},[_c('v-autocomplete',{attrs:{"value":_vm.modelProfile,"items":_vm.getProfiles,"rules":[_vm.rules.required],"label":_vm.$t('profile'),"item-text":"GroupName","item-value":"GroupName","outlined":"","dense":""},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }